<template>
  <CheckoutStep class="h-full">
    <template #header>
      <Stepper />
    </template>
    <template #aside>
      <GiftCardSummary
        v-if="giftCard"
        :asset-url="giftCard.designAsset.assetUrl"
        :price="giftCard.price"
      />
    </template>

    <div aria-live="polite" role="status">
      <BillingAddress :billing-address @update="handleUpdate" />
    </div>

    <RevButton
      size="small"
      variant="secondary"
      @click="redirectUsingWindowsLocationCancel"
    >
      Cancel using windows.location
    </RevButton>

    <RevButton
      size="small"
      variant="secondary"
      @click="redirectUsingWindowsLocationSuccess"
    >
      Success using windows.location
    </RevButton>

    <RevButton
      size="small"
      variant="secondary"
      @click="redirectUsingNavigateToCancel"
    >
      Cancel using navigateTo
    </RevButton>

    <RevButton
      size="small"
      variant="secondary"
      @click="redirectUsingNavigateToCancelAndReplace"
    >
      Cancel using navigateTo and replace
    </RevButton>

    <RevButton
      size="small"
      variant="secondary"
      @click="redirectUsingNavigateToSuccess"
    >
      Success using navigateTo
    </RevButton>
  </CheckoutStep>
</template>

<script setup lang="ts">
import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { RevButton } from '@ds/components/Button'

import type { Bill } from '~/api/cart/types'
import CheckoutStep from '~/scopes/checkout/components/CheckoutStep/CheckoutStep.vue'
import { CHECKOUT } from '~/scopes/checkout/routes-names'

import GiftCardSummary from '../../components/GiftCardSummary/GiftCardSummary.vue'
import Stepper from '../../components/Stepper/Stepper.vue'

import BillingAddress from './components/BillingAddress/BillingAddress.vue'

defineProps<{
  giftCard: ApiSpecs['/api/gift-cards/v1/product-page/giftcard/request/:requestId']['GET']['response']
  billingAddress: Bill
}>()

const emit = defineEmits<{
  (e: 'update', callback: () => void): void
}>()

function handleUpdate() {
  emit('update', () => {
    navigateTo({ name: CHECKOUT.GIFT_CARDS.PAYMENT })
  })
}

function redirectUsingWindowsLocationCancel() {
  window.location.href = 'backmarket://gcpp/cancel'
}

function redirectUsingWindowsLocationSuccess() {
  window.location.href = 'backmarket://gcpp/success'
}

async function redirectUsingNavigateToCancel() {
  await navigateTo('backmarket://gcpp/cancel', { external: true })
}

async function redirectUsingNavigateToCancelAndReplace() {
  await navigateTo('backmarket://gcpp/cancel', {
    external: true,
    replace: true,
  })
}

async function redirectUsingNavigateToSuccess() {
  await navigateTo('backmarket://gcpp/success', {
    external: true,
    replace: true,
  })
}
</script>
